import React from 'react';
import CareerGuidance2024 from 'views/CareerGuidance2024';

const BridgeCoursePage = () => {
  return <CareerGuidance2024/>;
};

export default BridgeCoursePage;